import { createContext } from "react";
import { CurrentData, Expansion, GlobalSettings, Product } from "types";

interface DataContextProps {
  product: Product | null;
  setProduct: (value: Product | null) => void;
  expansion: Expansion | null;
  setExpansion: (value: Expansion | null) => void;
  globalSettings: GlobalSettings | null;
  setGlobalSettings: (value: GlobalSettings | null) => void;
  isLoadingStateEntities: boolean;
  setIsLoadingStateEntities: (value: boolean) => void;
  isLoadingCurrentData: boolean;
  setIsLoadingCurrentData: (value: boolean) => void;
  currentData: CurrentData | null;
  setCurrentData: (value: CurrentData | null) => void;
}

const DataContext = createContext<DataContextProps>({
  isLoadingStateEntities: false,
  setIsLoadingStateEntities: () => {},
  isLoadingCurrentData: false,
  setIsLoadingCurrentData: () => {},
  product: null,
  setProduct: () => {},
  expansion: null,
  setExpansion: () => {},
  globalSettings: null,
  setGlobalSettings: () => {},
  currentData: null,
  setCurrentData: () => {},
});

export default DataContext;
